// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__NGCYs","spin":"Checkbox_spin__hei9W"};